import { render, staticRenderFns } from "./Cms.vue?vue&type=template&id=2bf05fbc&scoped=true&"
import script from "./Cms.vue?vue&type=script&lang=js&"
export * from "./Cms.vue?vue&type=script&lang=js&"
import style0 from "./Cms.vue?vue&type=style&index=0&id=2bf05fbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf05fbc",
  null
  
)

export default component.exports